import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { UrlsService } from '../../Services/urls.service';
import { SharedHttpClientService } from '../../Services/shared-http-client.service';
import { APIURL } from '../../Constant/API_Urls';
import { UserService } from '../../Services/user.service';
import { Router, ActivatedRoute, RouterModule  } from '@angular/router';
import { EmitterService } from '../../Services/emitter.service';
import { ConstantService } from '../../Services/constant-service';
import { StorageKeys } from 'app/Shared/Constant/StorageKeys';
import { DatePipe, CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService,ConfirmationService } from 'primeng/api';
import { first, Subscription } from 'rxjs';
import { environment } from "environments/environment";
import { DataService } from 'app/Shared/Services/data.service';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { DialogModule } from 'primeng/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { ToastModule } from 'primeng/toast';
import { DatepickerCalendarComponent } from '../datepicker-calendar/datepicker-calendar.component';
import { DatepickerService } from '../datepicker-calendar/datepicker.service';
import { Select } from 'primeng/select';
import { ToastHistoryService } from 'app/Shared/Services/toast-history-service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AuthServiceService } from 'app/Authentification/auth-service.service';

const COMPONENTS:any = [
  ToolbarComponent
];

const MODULES = [
  RouterModule, CommonModule, FormsModule, MatDividerModule,ButtonModule,
  ConfirmDialogModule, Select, MultiSelectModule, DialogModule, MatTooltipModule,
  MatIconModule,ToastModule,DatepickerCalendarComponent,AutoCompleteModule 
];
@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    imports: [
        ...MODULES, ...COMPONENTS
    ],
    providers: [],
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  @ViewChild('MPIDList') MPIDSelectionList!: ElementRef<HTMLSelectElement>;
  public selected_main_menu_number: any;
  public isActive_mainmenuNameis: any;
  public isActive_submenu: any;
  public tempActiveMenuName: any;
  public ExecutionDate: any;
  public temp_active_main_menu_number: any;
  public MenuArray: any;
  public User!: string;
  public selectedItem: any;
  public home = true;
  public url = '/pages/MainDashboard';
  public index: any;
  public MPID: any;
  public currentDate: Date = new Date();
  public MPIDS: any = [];
  public placeholder: string = 'Sign Out';
  public isProductionEnv: boolean = false;
  isLoadingValidate: boolean = false;
  msgs: any;
  displayDialog: boolean = false;
  fileProcessingType: any = "";
  groupListDropDown: any = [];
  fileListDropDown: any = [];
  selectedFiles : any = [];
  selectedGroup: any = null;
  reportDate: any = "";
  isLoadingGroupList: boolean=false;
  isLoadingFileList: boolean=false;
  isFileProcessingStated: boolean=false;
  lastReportDate: any;
  subscription:any= Subscription;
  showFileProcessbtn: boolean = false;
  regUserInProduction: boolean = false;
  fileProcessType!: string;
  isgenCATEvents: string = "N";
  isLoadingGenerate:boolean=false;
  isLoadingSubmit:boolean=false;
  isLoadingFetch:boolean=false;
  urlEncodedFilterParams: object | any = new Object();
  isToastMessageHistory: boolean = false;
  lastMessages:any[]=[];
  hasUnread :boolean =false;
  filterMPIDs:any;
  previousMPID:any;

  constructor(private urlService: UrlsService,
    public UserService: UserService,
    private router: Router,
    private sharedHttpClientService: SharedHttpClientService,
    private emitterService: EmitterService,
    public constantService: ConstantService,
    public dataService:DataService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService,
    public activatedRoute: ActivatedRoute,
    public datePipe: DatePipe,
    private datepickerSerivce:DatepickerService,
    private toastHistoryService:ToastHistoryService,
    public authenticationService: AuthServiceService,
  ) {
    this.isProductionEnv = environment.apiUrl === this.constantService.prodApiUrl;
    /* Auto Change MPID from TOP-Right MPID SelectionList if it's available in Encoded URL Parameter */
      this.urlEncodedFilterParams = this.dataService.getViewerEncodedURLParameters(); // Decode URL Params passed from any Screen
      if(this.urlEncodedFilterParams["activeMPID"]) {
        if (this.MPIDSelectionList) {
          this.MPIDSelectionList.nativeElement.value = this.urlEncodedFilterParams["activeMPID"];        
          this.MPIDSelectionList.nativeElement.dispatchEvent(new Event('change')); // Manually dispatch a 'change' event to notify Angular
        }
      }
    /* End of Auto Change MPID from TOP-Right MPID SelectionList if it's available in Encoded URL Parameter */
    this.toastHistoryService.messadeAdded.subscribe(()=>{
      this.hasUnread = true;
    })
  }

  ngOnInit() {
    this.getMenu();
    this.MPIDS = this.UserService.getMPLIDList();
    this.isActive_mainmenuNameis = 'home';
    this.MPID = this.UserService.getActiveMPID();
    this.previousMPID = this.MPID;
    let currentuser = JSON.parse(this.constantService.getSessionStorage(StorageKeys.User));
    if (currentuser) { this.User = currentuser.userFirstName; }

    if (this.UserService.isRoleUser() && this.isProductionEnv) {
		this.regUserInProduction = true;
    }

    this.subscription = this.emitterService.setActiveMenu.subscribe(setActiveMenuNumber => {
      /* Catch User Action Log */
        this.UserService.logUserActivity("Reviewed " + setActiveMenuNumber.MenuName + " Records", setActiveMenuNumber.page, {
          'Text1': this.UserService.userFirstName + ' reviewed ' + setActiveMenuNumber.SubMenuName + ' records from ' + setActiveMenuNumber.page,
          'Text2': 'User Filter Parameters: ' + JSON.stringify(setActiveMenuNumber)
        });
      this.constantService.routerURL();
      this.home = false;
      if (setActiveMenuNumber) {
        if (setActiveMenuNumber.MenuName == 'home') {
          this.home = true;
          this.selectedItem = 'home';
          this.isActive_submenu = 'home';
          this.isActive_mainmenuNameis = 'home';
          this.tempActiveMenuName = 'home';
          this.selected_main_menu_number = 99;
          this.temp_active_main_menu_number = 99;
        } else {

          this.mouseOver(setActiveMenuNumber.MenuName);
          this.setMenuindex(setActiveMenuNumber.MenuId);
          this.isActive(setActiveMenuNumber.SubMenuName);
          this.setActiveMenuindex();
        }
      }
    });
    this.subscription = this.emitterService.onMouseOutMainWindow.subscribe( event => {
      this.mouseWindowOut(event);
    });
  }
  setActiveMenuAfterReload() {
    this.constantService.getApplicationName();
    if(this.constantService.SubMenu){
    this.mouseOver(this.constantService.MainMenu);
    this.setMenuindex(this.findMenuIndex(this.constantService.MainMenu));
    this.isActive(this.constantService.SubMenu);
    this.setActiveMenuindex();
    }
  }

  findMenuIndex(menu: any) {
    let i = 0;
    for (const element of this.MenuArray) {
      let menuName = element['menuType'];
      let formattedMenu = menu.replace(/-/g, ' ');
      if (menuName == formattedMenu) {
        return i;
      }
      i++;
    }
    return 99;
  }

  getMainTabName() {
   let currentURL:any = this.activatedRoute.snapshot;
    return (currentURL['_routerState'].url).split('/')[2]; 
  }


  onMouseOut(event: any): void {
        if (this.isActive_mainmenuNameis != 'home') {
        this.home = false;
        }
  }

  mouseWindowOut($event: any) {
    if (this.isActive_mainmenuNameis == 'home') {
      this.home = true;
      this.selected_main_menu_number = 99;
      this.temp_active_main_menu_number = 99;
    }
    else {
      this.home = false;
      this.temp_active_main_menu_number = this.selected_main_menu_number;
    }
    this.tempActiveMenuName = "";
  }

  /*   listClick($event: any) {
      if ($event == 'home') {
        this.home = true;
        this.isActive_mainmenuNameis = $event;
        this.isActive_submenu = $event;
        this.tempActiveMenuName = $event;
        this.selectedItem = $event;
        this.router.navigate(['/pages/MainDashboard']);
      } else { this.home = false }
      this.selectedItem = $event;
    } */

  isActive($event: any) {
    if ($event == 'home') {
      this.home = true;
      this.selectedItem = $event;
      this.isActive_submenu = $event;
      this.isActive_mainmenuNameis = $event;
      this.tempActiveMenuName = $event;
      this.selected_main_menu_number = 99;
      this.temp_active_main_menu_number = 99;
      this.router.navigate(['/pages/MainDashboard']);
    }
    else if($event == 'Toolbar') {
      this.selectedItem = "home";
    }
    else {
      this.home = false
      this.selectedItem = $event;
      this.isActive_submenu = $event.replace(/\-/g, ' ');
      this.isActive_mainmenuNameis = this.tempActiveMenuName; 
    }
    this.checkFileProcessBtn();
    this.isToastMessageHistory = false;
  }

  checkFileProcessBtn() {
    this.showFileProcessbtn = false;
    if (this.isActive_submenu == 'CAT ROE Viewer') {
      this.showFileProcessbtn = true;
      this.fileProcessType="ROE";
      this.lastReportDate = this.UserService.getyyyyMMddDateFormate(this.UserService.CATLastExecutionDate);
      this.reportDate = this.UserService.CATLastExecutionDate;
    } else if (this.isActive_submenu == 'CAT Exception') {
      this.showFileProcessbtn = true;
      this.fileProcessType="CAT";
      this.lastReportDate = this.UserService.getyyyyMMddDateFormate(this.UserService.CATLastExecutionDate);
      this.reportDate = this.UserService.CATLastExecutionDate;
    } 
    else if (this.isActive_submenu == 'Finra Exception') {
      this.isFileProcessingStated=false;
      this.showFileProcessbtn = true;
      this.fileProcessType="Finra";
      this.lastReportDate = this.UserService.getyyyyMMddDateFormate(this.UserService.FinraCATLastExceptionReportDate);
      this.reportDate = new Date();
    } else if (this.getMainTabName() === 'CAIS' && this.isActive_submenu !== 'CAIS Audit Trails') {
      this.isFileProcessingStated = false;
      this.showFileProcessbtn = true;
      this.fileProcessType="CAIS";
    } else {
      this.reportDate = this.UserService.getDatesForClientData()[0];
    }
  }

  setActiveMenuindex() {
    this.selected_main_menu_number = this.temp_active_main_menu_number;
    }

  goToSubMenu(url: string) {  
    this.UserService.getLastReportedDate();
    this.UserService.getLastReportedClientDate();
    this.router.navigate(['/pages/' + url]);
  }

  setMenuindex(i: any) {
    this.temp_active_main_menu_number = i;
  }

  mouseOver($event: any) {
    if ($event == 'home') {
      this.home = true;
      this.tempActiveMenuName = $event;
      this.selectedItem = $event;
    } else {
      this.home = false;
      this.tempActiveMenuName = $event;
      this.selectedItem = $event;
    }
  }

  passIndexValue(index: any) {
    this.temp_active_main_menu_number = index;
  }

  ngAfterViewInit() {
    //    this.getLastExecutiondate();
    this.getMenu();
  }

  onChange(newValue: any) {
    this.previousMPID = newValue;
    this.constantService.setSessionStorage(StorageKeys.MPID, JSON.stringify({
      defaultMPID: newValue
    }), 1);
    let isReloadMainDashboard = (this.UserService.getActiveMPID() != newValue) ? true : false; // Check Reload Dashboard Event should trigger OR not 
    this.UserService.setActiveMPID(newValue);
    this.UserService.getMPIDServieList(); // Re-initialize Accessible MPID-Service List
    this.UserService.getLastReportedDate();
    this.UserService.getLastReportedClientDate();
    if (isReloadMainDashboard) {
      this.MPID = newValue;
      this.constantService.setSessionStorage(StorageKeys.MPID,
        JSON.stringify({
          defaultMPID: this.MPID,
        }), 1);
      this.emitterService.reloadMainDashBoard.emit(true);
    }
  }
  getMenu() {
    this.sharedHttpClientService.get(
      this.urlService.setAPIURl1(
        APIURL.Menu,
        this.UserService.getUserName()) + "/")
      .subscribe({
        next: (result:any) => {
          this.MenuArray = result;
          this.setActiveMenuAfterReload();
        },
        error: (e) => {
            console.error(e);
        }
      });
  }

  getGroupList() {
    this.fileListDropDown = [];
    this.selectedFiles = [];
    if(this.getMainTabName() != 'CAIS'){
    this.isLoadingGroupList = true;
    this.sharedHttpClientService.post(this.urlService.setAPIURl(APIURL.CAT_Get_Group_List),
      {
        validationType: this.fileProcessingType,
        mpid: this.UserService.getActiveMPID(),
        reportDate:this.UserService.getyyyyMMddDateFormate(this.reportDate)
      })
      .subscribe({
        next: (response:any) => {
          let result = response;
            this.groupListDropDown = [];
            let DataSet: any[] = result.Data;
            if(DataSet && DataSet.length > 0) {
              for (let i = 0; i < DataSet.length; i++) {
                this.groupListDropDown.push({ label: DataSet[i].GroupName, value: DataSet[i].GroupName });
              }
            }    
            this.isLoadingGroupList = false;
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: "Loading group list", detail: "Data not found for that report date." });
          this.isLoadingGroupList = false;
        }
        });
      }
  }

  onGroupSelect(event : any){
    this.getFileList();
  }


  getFileList(){
    this.isLoadingFileList = true;
    let url = "";
 
    if(this.fileProcessingType=="Generate"){
      url = APIURL.CAT_Get_File_List;
    }else {
      url = APIURL.GET_CLIENT_FILE_LIST;
    }
    
    this.sharedHttpClientService.post(this.urlService.setAPIURl(url),
      {
        mpid: this.UserService.getActiveMPID(),
        reportDate:this.UserService.getyyyyMMddDateFormate(this.reportDate),
        groupName: this.selectedGroup
      })
      .subscribe({
        next: (response:any) => {
          this.isLoadingFileList = false;
        let result = response;
        this.fileListDropDown = [];
        let DataSet: any[] = result.data;
        if(DataSet && DataSet.length > 0) {
          for (let i = 0; i < DataSet.length; i++) {
            this.fileListDropDown.push({ label: DataSet[i], value: DataSet[i] });
          }
        }
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: "Loading File list", detail: "Data not found for that report date." });
         this.isLoadingFileList = false;
        }
      });
  }

  startFileProcessing() {
    if (this.reportDate && ( this.selectedGroup || this.fileProcessType=='Finra' || this.fileProcessType === "CAIS")) {
      if(this.fileProcessType=="ROE" &&  this.fileProcessingType == "Correction") {
        this.catROEValidation();
      } else {
        this.catScriptCall(this.fileProcessType);
      }
    } else {
      this.isFileProcessingStated = false;
      this.messageService.add({ severity: 'warn', summary: this.fileProcessingType, detail: "Please select All Details" });
    }
  }

  catROEValidation(){
    this.messageService.add({ severity: 'success', summary: "File Processing", detail: this.fileProcessingType + " File Processing Started"});
    this.UserService.logUserActivity((this.fileProcessingType==='Correction' ? 'Validate' : this.fileProcessingType), this.isActive_submenu, {
      'Text1': 'ROE Validation started by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (this.selectedGroup ? this.selectedGroup : this.UserService.getActiveMPID()),
      'Text2': 'File ' + (this.fileProcessingType==='Correction' ? 'Validate' : this.fileProcessingType) + ' Started'
    });
    this.displayDialog = false;
    this.isFileProcessingStated = true;
    let tempURl = this.urlService.setAPIURl(
      APIURL.CAT_ROE_Viewer_Validation);
    this.sharedHttpClientService.post(tempURl, {
      mpid: this.UserService.getActiveMPID(),
      groupName: this.selectedGroup,
      reportDate: this.UserService.getyyyyMMddDateFormate(this.reportDate)
    })
      .subscribe({
        next: (response:any) => {
          let result = response;
        this.isFileProcessingStated = false;
        let recordsCount=0;
        recordsCount = result.movedRecordsList.length;
        if (result.status == "false") {
          this.messageService.add({ severity: 'error', summary: "ROE Validation", detail: result.msg});
          this.UserService.logUserActivity((this.fileProcessingType==='Correction' ? 'Validate' : this.fileProcessingType), this.isActive_submenu, {
            'Text1': 'ROE Validation started by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (this.selectedGroup ? this.selectedGroup : this.UserService.getActiveMPID()),
            'Text2': result.msg
          });
        } else {
            this.messageService.add({ severity: 'success', summary: "ROE Validation", detail: "Moved Records ("+recordsCount+") for Validation" });
            this.UserService.logUserActivity((this.fileProcessingType==='Correction' ? 'Validate' : this.fileProcessingType), this.isActive_submenu, {
              'Text1': 'ROE Validation started by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (this.selectedGroup ? this.selectedGroup : this.UserService.getActiveMPID()),
              'Text2': 'Moved Records ('+recordsCount+') for Validation'
            });
          if(recordsCount>0) {
            this.catScriptCall("CAT")
          } else {
            this.messageService.add({ severity: 'warn', summary: "ROE Validation", detail: "Please update the record for validation"});
            this.UserService.logUserActivity((this.fileProcessingType==='Correction' ? 'Validate' : this.fileProcessingType), this.isActive_submenu, {
              'Text1': 'ROE Validation started by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (this.selectedGroup ? this.selectedGroup : this.UserService.getActiveMPID()),
              'Text2': 'Please update the record for validation'
            });
          }
        }
        },
        error: (err: HttpErrorResponse) => {
          this.isLoadingValidate = false;
              this.isFileProcessingStated = false;
              this.messageService.add({ severity: 'error', summary: "ROE Validation", detail:"ROE Validation Failed"  });
              this.UserService.logUserActivity((this.fileProcessingType==='Correction' ? 'Validate' : this.fileProcessingType), this.isActive_submenu, {
                'Text1': 'ROE Validation started by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (this.selectedGroup ? this.selectedGroup : this.UserService.getActiveMPID()),
                'Text2': 'ROE Validation Failed'
              });
        }
      });
  }

  catScriptCall(fileProcessType: string){
    this.messageService.add({ severity: 'success', summary: "File Processing", detail: this.fileProcessingType + " File Processing Started" });
    this.UserService.logUserActivity((this.fileProcessingType==='Correction' ? 'Validate' : (this.fileProcessingType==='CAT' ?  this.fileProcessingType + ' ROE Creation' : this.fileProcessingType)), this.isActive_submenu, {
      'Text1': this.fileProcessingType + ' File Processing Started by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (fileProcessType=='Finra'?this.UserService.getActiveMPID():(this.selectedGroup?this.selectedGroup:this.UserService.getActiveMPID())),
      'Text2': 'File ' + (this.fileProcessingType==='Correction' ? 'Validation' : (this.fileProcessingType==='Generate' ? 'Generation' : 'Processing')) + ' Started'
    });
    let scriptType;
    if(this.fileProcessingType === 'CAT'){
    scriptType ='CAT ROE Creation';
    }
    else if(this.isActive_submenu == 'Exception' && this.fileProcessType === 'CAIS' && this.fileProcessingType === 'Correction'){
      scriptType = 'CAIS '+this.UserService.caisExceptionType+" "+this.fileProcessingType;
    }else{
    scriptType = fileProcessType+" "+this.fileProcessingType;
    }

    this.displayDialog = false;
    this.isFileProcessingStated = true;
    let tempURl = this.urlService.setAPIURl(
      APIURL.RunScript);
    
    this.sharedHttpClientService.post(tempURl, {
      scriptType: scriptType,
      fileProcessType:  this.fileProcessingType,
      mpid: this.UserService.getActiveMPID(),
      submitterID: this.selectedGroup,
      reporterID: this.UserService.getActiveMPID(),
      groupName: (fileProcessType=='Finra' || fileProcessType==='CAIS')?this.UserService.getActiveMPID():this.selectedGroup,
      reportDate: this.UserService.getyyyyMMddDateFormate(this.reportDate),
      user: this.UserService.userFirstName,
      genCatEvents: this.isgenCATEvents,
      fileName : this.selectedFiles.length > 0 ? "\""+this.selectedFiles.join(' ')+"\"" : ""
    })
     .subscribe({
        next: (response: any) => {
          this.isgenCATEvents = 'N';
          let result = response;
          this.isFileProcessingStated = false;
          if (result.isScripttypeFailed == "true") {
            this.messageService.add({ severity: 'error', summary: result.Scripttype, detail: "File Processing Failed" });
            this.UserService.logUserActivity((this.fileProcessingType === 'Correction' ? 'Validate' : (this.fileProcessingType === 'CAT' ? this.fileProcessingType + ' ROE Creation' : this.fileProcessingType)), this.isActive_submenu, {
              'Text1': this.fileProcessingType + ' File Processing Failed by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (fileProcessType == 'Finra' ? this.UserService.getActiveMPID() : (this.selectedGroup ? this.selectedGroup : this.UserService.getActiveMPID())),
              'Text2': 'File ' + (this.fileProcessingType === 'Correction' ? 'Validation' : (this.fileProcessingType === 'Generate' ? 'Generation' : 'Processing')) + ' Failed'
            });
          } else {
            this.messageService.add({ severity: 'success', summary: result.Scripttype, detail: "File Processing Completed" });
            this.UserService.logUserActivity((this.fileProcessingType === 'Correction' ? 'Validate' : (this.fileProcessingType === 'CAT' ? this.fileProcessingType + ' ROE Creation' : this.fileProcessingType)), this.isActive_submenu, {
              'Text1': this.fileProcessingType + ' File Processing Completed by ' + this.UserService.getUserName() + ' for the Report Date: ' + this.UserService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + (fileProcessType == 'Finra' ? this.UserService.getActiveMPID() : (this.selectedGroup ? this.selectedGroup : this.UserService.getActiveMPID())),
              'Text2': 'File ' + (this.fileProcessingType === 'Correction' ? 'Validation' : (this.fileProcessingType === 'Generate' ? 'Generation' : 'Processing')) + ' Completed'
            });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.isgenCATEvents = 'N';
          this.isLoadingValidate = false;
          this.isFileProcessingStated = false;
        }
        });
    }

  getGroupListDateChange() {
    this.getGroupList();
  }

  fileProcessing(type: any) {
      this.selectedGroup = null;
      this.fileProcessingType = type;
      this.isLoadingGroupList=false;
      this.getGroupList();
      this.displayDialog = true;
  }

  sendToSubmitState() {
      this.confirmationService.confirm({
        message: 'Do you want to Proceed? Move all records from \'Not Submitted\' to \'Submitted\'',
        key: 'submitInformationDialoge',
        acceptLabel: 'Ok',
        acceptIcon:'pi pi-check',
        rejectLabel: 'No',
        rejectIcon:'pi pi-times',
        acceptButtonStyleClass:"information-dialog-button",
        rejectButtonStyleClass:"information-dialog-button information-reject-button",

        accept: () => {
          this.displayDialog = false;
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: 'Records are moving...' });
          let payLoad = {
            type: this.UserService.CAISFDIDRecordType,
            mpid: this.UserService.getActiveMPID(),
            user: this.UserService.getUserName(),
            userName: this.UserService.getUserFirstName(),
            reportDate: this.UserService.getyyyyMMddDateFormate(this.UserService.CAISLastReportDate)
          };
          this.sharedHttpClientService.post(
            this.urlService.setAPIURl(
              APIURL.Move_Staging_To_Master
            ), payLoad)
          .subscribe((res) => {
            let resultSet: any = res;
            if(resultSet) {
              this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: 'Moved Records from \'Not Submitted\' to \'Submitted\'' });
              this.UserService.logUserActivity('Move to \'Not Submitted\' to \'Submitted\' State', this.isActive_submenu, {
                'Text1': 'Moved Records from \'Not Submitted\' to \'Submitted\' successfully',
                'Text2': ''
              });
            } else {
              this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Failed Moving Records from \'Not Submitted\' to \'Submitted\'' });
              this.UserService.logUserActivity('Move to \'Not Submitted\' to \'Submitted\' State', this.isActive_submenu, {
                'Text1': 'Failed to move Records from \'Not Submitted\' to \'Submitted\' State',
                'Text2': ''
              });
            }
          });
        },
        reject: () => {
          this.displayDialog = false;
      }
     
      });
  }

  logout() {
    this.authenticationService.mfa_logout(this.UserService.getUserName())
      .pipe(first())
      .subscribe({
        next: (result: any) => {
          this.clearUserDetails();
        }, error: (err: HttpErrorResponse) => {
          this.clearUserDetails();
        }
      });
  }

  clearUserDetails(){
    this.UserService.setClear();
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem(StorageKeys.User);
    this.constantService.clearAllStorage();
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  getDateEmitter(){
    this.reportDate = this.datepickerSerivce.reportDate;
    this.getGroupListDateChange();
  }
  showToastMessgae(){
    this.isToastMessageHistory = true;
    this.lastMessages =this.toastHistoryService.getHistoryMessage();
    this.toastHistoryService.markAllAsRead();
    this.hasUnread = false;
  }
  filteredMPIDList(event: any) {
    const query = (event.query || '').toString().trim().toLocaleLowerCase();
    this.filterMPIDs = this.MPIDS.map((item:any)=>item.mpid).filter((item:any)=>item.toLocaleLowerCase().includes(query));
    }
    onMPIDChange(){
      if(!this.MPID && this.previousMPID){
        setTimeout(()=>{
        this.MPID = this.previousMPID;
        })   
      }
    }
}